import {writable} from 'svelte/store'
import {socket} from './io'
import log from './log'

// Expose connection state
export const connected = writable(false)
export const server = writable('')

let state
connected.subscribe(val => state = val)

// Connect to vMix
export function open({host, port}) {
	if (state)
		return 'Connection already open'

	socket.emit('open', {host, port})
	name = host + ':' + port
	server.set(name)
}

socket.on('ready', () => {
	connected.set(true)
})

socket.on('reconnect', () => {
	socket.emit('get state')
})

socket.on('name', name => {
	server.set(name)
})

export function send(command, sender = 'client') {
	if (!state)
		return 'Connection already closed'

	socket.emit('command', command + '\r\n')
	log.push(sender, command)
}

// End connection
export function close() {
	if (!state)
		return 'Connection already closed'

	socket.emit('close')
}

socket.on('close', () => {
	connected.set(false)
	server.set('')
})
